import { DOMAIN } from "../utilities/consts";

class GasApi {
  static getData(config) {
    return fetch(`${DOMAIN}/ZeekAppsWS.asmx/ObtenerDatosGas`, {
      //mode: "cors",
      method: "POST",
      body: JSON.stringify(config),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => response.json())
      .then(data => JSON.parse(data.d));
  }

  static getFakeData() {
    return fetch(`/fakedata/gas.json`)
      .then(response => response.json())
      .then(data => data);
  }
}

export default GasApi;



// WEBPACK FOOTER //
// ./src/api/gas.js